<template>
  <section class="web-content-page">
    <h1>Account & Audit</h1>
    <div class="main-container">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick">
        <el-tab-pane
          label="Account Manager"
          name="password"></el-tab-pane>
        <el-tab-pane
          label="Agents"
          name="agents"></el-tab-pane>
        <el-tab-pane
          label="SMS Log"
          name="sms"></el-tab-pane>
        <el-tab-pane
          label="Email Log"
          name="email"></el-tab-pane>
        <el-tab-pane
          label="Audit Log"
          name="audit"></el-tab-pane>
      </el-tabs>
      <div  v-if="activeName!='sms'&&activeName!='email'&&activeName!='password'">
        <div class="transparent-block">
          <el-table

            :data="tableData"
            style="width: 100%"
            :header-row-class-name="'tableHeader'"
            @row-click="rowClick"
          >
            <el-table-column
              label="All Agents">
              <template #default="{ row }">
                <div class="flex">
                  <font-awesome-icon
                    icon="headset"
                    class="pointer"
                  />
                  <div class="margin-left">
                    <span class="action-title">{{ row.created_date }}</span><br>
                    <span class="little-span">{{ row.created_date }}</span><br>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>

        </div>
        <v-pagination
          :total="pageConfig.total"
          :current="pageConfig.currentPage"
          @currentChange="currentChange"/>
      </div>
      <change-password v-if="activeName=='password'"></change-password>
      <sms-log v-if="activeName=='sms'"></sms-log>
      <email-log v-if="activeName=='email'"></email-log>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getNesLetterList} from '@/api/newsletter'
import SmsLog from '@/views/administration/sms-log'
import EmailLog from '@/views/administration/components/email-log'
import changePassword from '@/views/administration/components/change-password'

export default {
  name: 'accountAuditPage',
  components: {SmsLog,EmailLog,changePassword},
  mixins: [MixinOptions],
  data() {
    return {
      activeName:'password',
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      search: '',
      tableData: []
    }
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        this.network().getNesLetterList()
      }
    }
  },
  methods: {
    handleClick(){

    },
    rowClick(row) {
      this.$router.push({
        path: '/administration/account/audit/detail',
        query: {

        }
      })
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getNesLetterList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getNesLetterList()
    },
    network() {
      return {
        getNesLetterList: async () => {
          const { data } = await getNesLetterList({
            search: this.search,
            page: this.pageConfig.currentPage
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.web-content-page {
  position: relative;
  h1 {
    padding-bottom: 15px;
    color: #616266;
    font-size: 20px;
  }

  .inline-input{
    display: flex;
    align-items: center;
    .to-span{
      margin: 0 10px;
    }
  }
  .transparent-block{
    border: 1px solid #E1E4E8;
    //border-bottom: 0;
    border-radius: 5px;
  }
  ::v-deep .tableHeader{
      height: 20px;
      width: 80px;
      color: #24292E;
      font-family: Inter;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 20px;
    th{
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      color: #24292E!important;
    }

  }
  .name-title{
    color: #24292E;
    font-weight: bold;
  }
  ::v-deep .el-table{
    border-radius: 5px;
  }
  .flex{
     padding: 15px 16px;
    align-items: baseline;
    .margin-left{
      margin-left: 8px;
    }
  }
  .action-title{
      color: #24292E;
      font-family: Inter;
      font-size: 16px;
      font-weight: 600;
  }
  .little-span{
    color: #6A737D;
    font-family: Inter;
    font-size: 12px;
  }
}
</style>
